import {
  EXAM_COURSE_LANGUAGE_TEXT,
  EXAM_COURSE_TYPE_TEXT,
} from '@exam-center/exam-course-management';
import type { ExamCourseLanguage, ExamCourseType } from '@exam-center/graphql';
import { EllipsisText, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface ExamCenterExamCourseListItem {
  id: string;
  examId: string;
  code: string;
  name: string;
  type: ExamCourseType;
  language: ExamCourseLanguage;
  createdAt: string;
}

export const columns: GridColDef<ExamCenterExamCourseListItem>[] = [
  {
    field: 'examId',
    headerName: 'ExamID',
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    width: 100,
  },
  {
    field: 'code',
    headerName: 'Code',
    sortable: false,
    width: 210,
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    sortable: false,
    width: 80,
    renderCell: ({ row }) => {
      const { type } = row;
      return <EllipsisText>{EXAM_COURSE_TYPE_TEXT[type]}</EllipsisText>;
    },
  },
  {
    field: 'language',
    headerName: 'Language',
    sortable: false,
    width: 94,
    renderCell: ({ row }) => {
      const { language } = row;
      return <EllipsisText>{EXAM_COURSE_LANGUAGE_TEXT[language]}</EllipsisText>;
    },
  },
  {
    field: 'createdAt',
    headerName: 'Date Added',
    sortable: false,
    width: 160,
    valueFormatter: (params) => {
      return `${params.value ? formatDateTime(params.value) : '-'}`;
    },
  },
];
